module.exports = __webpack_public_path__ + "img/num02.bb987c6e.png";